import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CompetencyTypesService } from 'app/_services/competency-types.service';
import { NotificationService } from 'app/_services/notification.service';
import { SiteRequiredCompetencyDTO, SiteRequiredCompetencyService } from 'app/_services/site-required-competency.service';
import { forkJoin, of } from 'rxjs';

@Component({
  selector: 'edit-site-required-competencies',
  templateUrl: './edit-site-required-competencies.component.html',
})
export class EditSiteRequiredCompetenciesComponent implements OnInit {
  @Input() site: any;
  @Input() existingRequired: SiteRequiredCompetencyDTO[] = [];

  public form: FormGroup;
  public allCompetencies: any[] = [];
  public isLoading = true;
  public hasLoadError = false;
  public isSubmitting = false;

  // competencyTypeId -> existing site_required_competency.id
  private existingRowsByTypeId: Map<number, number> = new Map();

  constructor(
    private activeModal: NgbActiveModal,
    private competencyService: CompetencyTypesService,
    private siteRequiredCompetencyService: SiteRequiredCompetencyService,
    private notificationService: NotificationService,
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      competencies: new FormControl([]),
    });

    this.existingRowsByTypeId = new Map(
      (this.existingRequired || []).map(item => [item.competencyTypeId, item.id] as [number, number]),
    );

    this.competencyService.getAllCompetencyTypesByTypeFilteredForSiteOwner('GENERAL_SITE', this.site.siteOwner.id).subscribe(
      (allTypes: any[]) => {
        this.allCompetencies = (allTypes || [])
          .map(element => ({ label: element.value, value: element.id }))
          .sort((a, b) => a.label.localeCompare(b.label));

        this.form.controls.competencies.setValue(Array.from(this.existingRowsByTypeId.keys()));
        this.isLoading = false;
      },
      () => {
        this.notificationService.notify('danger', 'Error', 'Could not load site competencies.');
        this.isLoading = false;
        this.hasLoadError = true;
      },
    );
  }

  public closeModal() {
    this.activeModal.dismiss();
  }

  public onSubmit() {
    const selectedIds: number[] = this.form.value.competencies || [];

    const toAdd = selectedIds.filter(id => !this.existingRowsByTypeId.has(id));
    const toDeleteRowIds: number[] = [];
    this.existingRowsByTypeId.forEach((rowId, typeId) => {
      if (selectedIds.indexOf(typeId) === -1) {
        toDeleteRowIds.push(rowId);
      }
    });

    const createObservableRequiredCompetencies = toAdd.length
      ? this.siteRequiredCompetencyService.createMultiple(
          toAdd.map(competencyTypeId => ({ siteId: this.site.id, competencyTypeId })),
        )
      : of(null);

    const deleteObservableRequiredCompetencies = toDeleteRowIds.length
      ? toDeleteRowIds.map(rowId => this.siteRequiredCompetencyService.delete(rowId))
      : [of(null)];

    this.isSubmitting = true;
    forkJoin([createObservableRequiredCompetencies, ...deleteObservableRequiredCompetencies]).subscribe(
      () => {
        this.notificationService.notify('success', 'Updated site competencies');
        this.activeModal.close('refresh');
      },
      (error) => {
        this.isSubmitting = false;
        this.notificationService.notify('danger', 'Error', 'Could not update site competencies. Refreshing data.');
        this.activeModal.close('refresh');
        throw error;
      },
    );
  }
}
